export default (type) => {
    switch (type) {
        case 'positive':
            return 'spark-icon-check'
        case 'warning':
            return 'spark-icon-alert-triangle'
        default:
            return 'spark-icon-note'
    }
}


// WEBPACK FOOTER //
// ./src/shared/utils/toastIcon.js